<div class="lp-image-canvas-component" style="width: 100%; height: 100%">
  <app-visual-element [url]="comp().image.url" fit="contain" />
</div>
